<script lang="ts">
	import { Modal, Tabs, Tab, Button } from '@Shelly/shelly-design-system';
	import type { ISceneObj } from '../../../types/SceneType';
	import PropertyPanel from '../PropertyEditors/PropertyPanel.svelte';

	export let showModal = false;
	export let isMobile = false;
	export let scene: ISceneObj | null = null;
	export let initialTab: 'general' | 'validation' | 'history' = 'general';
	export let onClose: () => void;
	export let onSave: () => void;
	export let onFocusNode: (nodeId: string) => void;

	let activeTab: 'general' | 'validation' | 'history' = 'general';

	// Parent updates the requested tab and visibility in the same render cycle.
	// React directly to both props so the validation shortcut never opens on General.
	$: if (showModal) activeTab = initialTab;
</script>

<Modal
	{showModal}
	title="Flow settings"
	type={isMobile ? 'fullScreen' : 'default'}
	backdropClose={false}
	on:close={onClose}
>
	<svelte:fragment slot="toolbar">
		<Tabs useNewLayout class="settings-tabs">
			<Tab useNewLayout active={activeTab === 'general'} on:click={() => (activeTab = 'general')}>
				General
			</Tab>
			<Tab
				useNewLayout
				active={activeTab === 'validation'}
				on:click={() => (activeTab = 'validation')}
			>
				Validation
			</Tab>
			<Tab useNewLayout active={activeTab === 'history'} on:click={() => (activeTab = 'history')}>
				History
			</Tab>
		</Tabs>
	</svelte:fragment>

	<svelte:fragment slot="content">
		<div class="settings-content">
			<PropertyPanel
				{scene}
				showScene={activeTab === 'general'}
				showNode={false}
				showValidation={activeTab === 'validation'}
				showHistory={activeTab === 'history'}
				{onFocusNode}
			/>
		</div>
	</svelte:fragment>

	<div slot="footer" class="settings-footer">
		<Button variant="secondary" on:click={onClose}>Cancel</Button>
		<Button variant="primary" on:click={onSave}>Save</Button>
	</div>
</Modal>

<style>
	:global(.settings-tabs) {
		width: 100%;
		max-width: 100%;
	}

	.settings-content {
		box-sizing: border-box;
		width: 100%;
		max-width: 100%;
		min-height: 280px;
	}

	.settings-footer {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
	}

	@media (max-width: 639px) {
		:global(.settings-tabs),
		.settings-content {
			width: 100%;
		}

		.settings-footer > :global(*) {
			flex: 1;
		}
	}
</style>
